import { render, staticRenderFns } from "./CreateFormOperate.vue?vue&type=template&id=9fb68cf6&v-if=this.open"
import script from "./CreateFormOperate.vue?vue&type=script&lang=js"
export * from "./CreateFormOperate.vue?vue&type=script&lang=js"
import style0 from "./CreateFormOperate.vue?vue&type=style&index=0&id=9fb68cf6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports